import Transformer from './../transformer'

export default class CampTransformer extends Transformer {
  static fetch(camp) {
    const rUser = camp.resident.user
    const resident = {
      ...camp.resident,
      user: {
        ...rUser,
        name: `${rUser.first_name} ${rUser.last_name} ${rUser.mothers_last_name}`
      }
    }
    return {
      id: camp.id,
      name: camp.name,
      address: camp.address,
      distanceToExit: camp.distance_to_exit,
      highwayKm: camp.highway_km,
      resident,
      residentId: camp.resident.id,
      state: camp.state.id,
      municipality: camp.municipality.id,
      stateMunicipality: `${camp.state.name} / ${camp.municipality.name}`,
    }
  }

  static send(camp) {
    return {
      id: camp.id,
      name: camp.name,
      address: camp.address,
      distance_to_exit: camp.distanceToExit,
      highway_km: camp.highwayKm,
      resident: camp.resident,
      state: camp.state,
      municipality: camp.municipality,
      resident: camp.residentId,
      confirmation: camp.confirmed
    }
  }
}


// WEBPACK FOOTER //
// ./src/transformers/catalog/camp.js